// extracted by mini-css-extract-plugin
export default {"passwordRequirements":"forgotPasswordComplete_passwordRequirements__FJWyS","passed":"forgotPasswordComplete_passed__BbfHU"};